import { render, staticRenderFns } from "./studorms.vue?vue&type=template&id=3ad1709d&scoped=true"
import script from "./studorms.vue?vue&type=script&lang=js"
export * from "./studorms.vue?vue&type=script&lang=js"
import style0 from "./studorms.vue?vue&type=style&index=0&id=3ad1709d&prod&lang=less"
import style1 from "./studorms.vue?vue&type=style&index=1&id=3ad1709d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad1709d",
  null
  
)

export default component.exports